import React, { useState, useEffect } from "react";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { store } from "../../../../helpers/store";
import { appService } from "./../../../../services/app.service";
import { Typography, Grid, Hidden, Menu } from "@material-ui/core";
import { STYLED_SELECT, STYLED_MENU_ITEM } from "../profile-account-dropdown/profile-account-dropdown-style";
import { updateAccountDetails, updateMeterDetails } from "./../../../../actions/home.action";
import { connect } from "react-redux";
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';

function ProfileAccountDropdown(props) {
  const [account, setAccount] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [multipleAccountDetails, setMultipleAccountDetails] = useState([]);

  let labels = {};
  if (appService.getLabels()) {
    labels = appService.getLabels().getLabels.HEADER;
  }

  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    getContentAnchorEl: null,
  };

  useEffect(() => {
    if(store.getState().accountInformation && store.getState().accountInformation.accountDetails) {
      const accId = store.getState().accountInformation.accountDetails[0].accountId
      const acc = multipleAccountDetails.find((acc) => acc.accountId === accId);
      setSelectedAccount(
        accId,
      );
      setAccount(
        acc,
      );
      let accountsArray = store.getState().accountInformation.accountDetails.filter((item) => item.accountId === accId )
      let personAccountList = store.getState().accountInformation.personAcccountDetail.personAccountList.filter((item) => item.accountId === accId)
      let personDetailList = store.getState().accountInformation.personDetailList
      let accountIdObject = {accountDetails:accountsArray, personAcccountDetail:{personAccountList:personAccountList}, personDetailList}
      props.updateAccountDetails(accountIdObject);
    let getFirstMeter = personAccountList ? personAccountList.find(singleAcc => !singleAcc.isDisabled) : {};
    props.updateMeterDetails(getFirstMeter,getFirstMeter.accountSaList[0]);
    }    
    
  },[multipleAccountDetails])


  const handleAccountOnChange = (event) => {
    const accId = event.target.value
    const acc = multipleAccountDetails.find((acc) => acc.accountId === accId);
    setSelectedAccount(
      accId,
    );
    setAccount(
      acc,
    );
    let accountsArray = store.getState().accountInformation.accountDetails.filter((item) => item.accountId === accId )
    let personAccountList = store.getState().accountInformation.personAcccountDetail.personAccountList.filter((item) => item.accountId === accId)
      let personDetailList = store.getState().accountInformation.personDetailList
      let accountIdObject = {accountDetails:accountsArray, personAcccountDetail:{personAccountList:personAccountList}, personDetailList}
      props.updateAccountDetails(accountIdObject);
    let getFirstMeter = personAccountList ? personAccountList.find(singleAcc => !singleAcc.isDisabled) : {};
    props.updateMeterDetails(getFirstMeter,getFirstMeter.accountSaList[0]);
  };


  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleMenuClose = () => {
    setAnchorEl(null);
  }

  const handleMenuCloseClick = (event, value) => {
    const accId = value
    setAnchorEl(null);
    setSelectedIndex(value);
    const acc = multipleAccountDetails.find((acc) => acc.accountId === accId);
    setSelectedAccount(
      accId,
    );
    setAccount(
      acc,
    );
    let accountsArray = store.getState().accountInformation.accountDetails.filter((item) => item.accountId === accId )
    let personAccountList = store.getState().accountInformation.personAcccountDetail.personAccountList.filter((item) => item.accountId === accId)
    let personDetailList = store.getState().accountInformation.personDetailList
    let accountIdObject = {accountDetails:accountsArray, personAcccountDetail:{personAccountList:personAccountList}, personDetailList}
    props.updateAccountDetails(accountIdObject);
    let getFirstMeter = personAccountList ? personAccountList.find(singleAcc => !singleAcc.isDisabled) : {};
    props.updateMeterDetails(getFirstMeter,getFirstMeter.accountSaList[0]);
  };

  const handleMenuOpenClick = (event) => {    
      setAnchorEl(event.currentTarget);    
  };
  
  let isdisable = false;
  if (multipleAccountDetails.length === 1) {
    isdisable = true;
  }

  const getAccountName = (personId) => {
    const personDetailList = store.getState().accountInformation.personDetailList;
    let singlePersonDetails, accountName, personNames, singlePersonName;
    if (Array.isArray(personDetailList)){
      singlePersonDetails = personDetailList && personDetailList.find((p) =>  p['C1-Person'].personId === personId);
      singlePersonDetails = singlePersonDetails['C1-Person'];
    } else {
      singlePersonDetails = personDetailList['C1-Person'];
    }

    if (singlePersonDetails){
      accountName = singlePersonDetails.personName.entityName;
      if (Array.isArray(singlePersonDetails.personName)){
        personNames = singlePersonDetails.personName;
        singlePersonName =  personNames && personNames.find((perName) =>  perName.personId === personId);       
        accountName = singlePersonName.entityName;
      } 
      else {
        accountName = singlePersonDetails.personName.entityName;
      }
    } 
       
    return accountName;
  };

  const getAccountType = (personId, accountInfo) => {
    const personDetails = store.getState().accountInformation.personDetailList;
    let c1Person, accountName, accountType;
    if (personDetails) {
      c1Person = personDetails['C1-Person'];
      if (Array.isArray(c1Person.personName)) {
        if (personId) {
          c1Person.personName.every(function (elem) {
            if (elem.personId == personId) {
              accountName = elem.entityName;
              return false;
            }
          });
        }
      }
      else {
        accountName = c1Person.personName.entityName;
      }
      if (accountInfo) {
        accountType = accountInfo.replace(accountName, "").split(",")[1];
      }
      return accountType;
    }
  };

  if (store.getState().accountInformation.accountDetails) {
    if (multipleAccountDetails.length === 0) {
      const AccountfilteredArr = store.getState().accountInformation.accountDetails.reduce((acc, current) => {
        const x = acc.find(item => item.accountId === current.accountId);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      setMultipleAccountDetails(AccountfilteredArr);
      setAccount(store.getState().accountInformation.accountDetails[0]);
      setSelectedAccount(store.getState().accountInformation.accountDetails[0].accountId);
    }
  }
  

   return <div></div> //(
  //   <Grid>
  //     <Hidden only={['xs']}>
  //       {account && (
  //         <Grid container>
  //           <Grid item align="right">
  //             <Typography
  //               color="primary"
  //             >
  //               SELECT ACCOUNT
  //             </Typography>
  //             <STYLED_SELECT
  //               className="accountDrop"
  //               name={"ddlAccounts"}
  //               value={selectedAccount}
  //               onChange={handleAccountOnChange}
  //               displayEmpty={true}
  //               IconComponent={ExpandMoreSharpIcon}
  //               disableUnderline={true}
  //               MenuProps={ddlMenuProps}
  //               disabled={isdisable}
  //               renderValue={() => account.personId && getAccountName(account.personId)}
  //             >
  //               {multipleAccountDetails && multipleAccountDetails.length > 1 && (multipleAccountDetails.map((acc) => (
  //                 <STYLED_MENU_ITEM
  //                   key={acc.accountId}
  //                   value={acc.accountId}
  //                 >                    
  //                   {acc.accountId + "-" + acc.accountInfo}
  //                 </STYLED_MENU_ITEM>
  //               )))
  //               }
  //             </STYLED_SELECT>
  //           </Grid>
  //         </Grid>

  //       )}
  //     </Hidden>

  //     <Hidden only={['sm', 'md', 'lg', 'xl']}>
  //       {account && (
  //         <Grid container alignItems="center">
  //           <Grid item>
  //             <Typography
  //               color="primary"
  //             >
  //               <b>{labels.HEADER_ACCOUNT ? labels.HEADER_ACCOUNT : "account"}
  //               </b>
  //             </Typography></Grid>
  //           <Grid item>
  //             <IconButton color="primary" size="medium" onClick={handleMenuOpenClick} aria-label="open" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
  //               <MoreVertIcon fontSize="large" />
  //             </IconButton>
  //             <Menu               
  //               id="simple-menu"
  //               anchorEl={anchorEl}
  //               keepMounted
  //               open={Boolean(anchorEl)}
  //               onClick={handleMenuClose}
  //               // onClose={handleMenuCloseClick}
  //               elevation={3}
  //               getContentAnchorEl={null}
  //               anchorOrigin={{
  //                 vertical: 'bottom',
  //                 horizontal: 'left',
  //               }}
  //               transformOrigin={{
  //                 vertical: 'top',
  //                 horizontal: 'center',
  //               }}
  //             >
  //               {multipleAccountDetails && multipleAccountDetails.length > 1 && (multipleAccountDetails.map((acc) => (
  //                 <STYLED_MENU_ITEM                    
  //                   key={acc.accountId}
  //                   value={acc.accountId}
  //                   selected={acc.accountId === selectedIndex}
  //                   onClick={(event) => handleMenuCloseClick(event, acc.accountId)}
  //                 >
  //                   {acc.accountId}
  //                 </STYLED_MENU_ITEM>
  //               )))
  //               }
  //             </Menu>
  //           </Grid>
  //         </Grid>
  //       )}
  //     </Hidden>
  //   </Grid>
  // );
}

const actionCreators = {
  updateAccountDetails: updateAccountDetails,
  updateMeterDetails: updateMeterDetails
};

const connectedProfileAccountDropdown = connect(null, actionCreators)(ProfileAccountDropdown);
export { connectedProfileAccountDropdown as ProfileAccountDropdown };
